export default "__VITE_ASSET__D4QKH64q__"